// src/components/img/GalerySectionVessels/VesselPatroklos.tsx
import React from 'react';
import vesselImage from './patroklos.jpeg';

const VesselPatroklos: React.FC = () => (
  <img src={vesselImage} alt="Vessel Patrokloss" />
);

export default VesselPatroklos;